module.exports = __webpack_public_path__ + "static/media/ls02.763cfea6.jpg";